import { CustomerAPI, json } from '@driftt/dapper'

export const getHasUpdatedSettingsSidebar = (orgId) => {
  return CustomerAPI.get(`/cutover/organizations/${orgId}?namespace=UPDATED_SETTINGS_SIDEBAR`)
    .then(json)
}



// WEBPACK FOOTER //
// ./src/scripts/components/settings/cutover.js